import * as React from 'react';
import { UIText1 } from '../../../../typography';
import { sanitizeMini } from '../../utils/sanitizeMini';
import { SUGGEST_MINIMUM_CHARACTERS_FOR_HIGHLIGHT_TO_WORK } from '../../constants';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export var TextHighlighter = function TextHighlighter(props) {
  if (!props.highlightValue || props.highlightValue.length < SUGGEST_MINIMUM_CHARACTERS_FOR_HIGHLIGHT_TO_WORK) {
    return /*#__PURE__*/_jsx(UIText1, {
      display: "inline",
      children: props.children
    });
  }
  var sections = props.children.split(new RegExp("(".concat(sanitizeMini(props.highlightValue), ")"), 'gi')).filter(function (maybeEmptyString) {
    return maybeEmptyString;
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: sections.map(function (section, index) {
      var _props$highlightValue;
      return /*#__PURE__*/_jsx(UIText1, {
        display: "inline",
        fontWeight: section.toLowerCase() === ((_props$highlightValue = props.highlightValue) === null || _props$highlightValue === void 0 ? void 0 : _props$highlightValue.toLowerCase()) ? '700' : '400',
        children: section
      }, index);
    })
  });
};